/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NameValuePair } from './nameValuePair';


/**
 * Параметры для поиска организаций.
 */
export interface OrganisationSearchParameters { 
    name?: string;
    businessTypeIds?: Array<string>;
    committeeIds?: Array<string>;
    jobTitleIds?: Array<string>;
    searchForExactMatchName?: boolean;
    organizationContact?: string;
    contacts?: Array<NameValuePair>;
}

